/**
 * Locations admin page localization (bg).
 */
export default {
  title: "Локации",
  subtitle: "Управление на физически локации и LIS съответствия",
  add: "Добавяне на локация",
  edit: "Редактиране",
  delete: "Изтриване",
  refresh: "Обновяване",
  navigate: "Отвори локация",
  add_title: "Добавяне на локация",
  add_subtitle: "Добавяне на нова физическа локация и LIS съответствие",
  subtitle_name: "Локация",
  subtitle_id: "ID на локация",
  subtitle_lis_id: "Код",
  subtitle_name_tooltip: "Наименование на локацията",
  subtitle_id_tooltip: "Системен идентификатор",
  subtitle_lis_id_tooltip: "ID на апарат в LIS iLab",
  edit_title: "Редактиране на локация",
  delete_title: "Изтриване на локация",
  delete_message: "Тази локация ще бъде изтрита окончателно.",
  delete_has_instruments: "Тази локация не може да бъде изтрита, защото има свързани апарати.",
  empty: "Все още няма локации",

  list: {
    status_total: "{count} локация | {count} локации",
    status_no_instruments: "Без апарати",
    status_with_instruments: "{count} апарат | {count} апарата",
    description: "Локациите групират апаратите по обект, отделение или сектор.",
    empty: {
      title: "Все още няма локации",
      description: "Добавете първата локация, за да организирате апаратите.",
    },
  },

  detail: {
    description: "Апарати, инсталирани на тази локация.",
    delete: "Изтриване на локация",
    edit: "Редактиране на локация",
    save: "Запази промените",
    reset: "Нулиране",
    details_tab: "Детайли",
    instruments: {
      tab: "Апарати",
      empty_title: "Няма апарати на тази локация",
      empty_description: "Свържете апарат с тази локация, за да го видите тук.",
    },
    toolbar: {
      refresh_instruments: "Обновяване",
      add_instrument: "Добавяне на апарат",
    },
  },

  tabs: {
    all: "Всички локации",
  },

  columns: {
    location: "Локация",
    name: "Име",
    mapping_key: "Код",
    mapping_key_tooltip: "Външен код за идентифициране на локацията в свързани LIS/HIS системи",
    note: "Бележка",
    instrument_count: "Апарати",
    actions: "Действия",
  },

  fields: {
    name: "Име",
    name_hint: "Показвано наименование в системата",
    name_placeholder: "напр. Лаборатория А, Отделение 3",
    mapping_key: "Код",
    mapping_key_hint: "ID на апарат в LIS iLab",
    mapping_key_placeholder: "напр. LOC01",
    note: "Бележка",
    note_hint: "По избор — видимо в заглавието и подсказките",
    note_placeholder: "напр. Основна лаборатория, приземен етаж",
  },

  validation: {
    name_required: "Името е задължително",
    name_too_long: "Името трябва да е най-много 100 символа",
    name_taken: "Вече съществува локация с това име",
    mapping_key_required: "Ключът е задължителен",
    mapping_key_too_long: "Ключът трябва да е най-много 100 символа",
    mapping_key_taken: "Вече съществува локация с този ключ",
    note_too_long: "Бележката трябва да е най-много 500 символа",
  },

  loadFailed: "Зареждането на локациите не успя",
  snackbar_added: 'Локация "{name}" е добавена',
  snackbar_updated: 'Локация "{name}" е обновена',
  snackbar_deleted: 'Локация "{name}" е изтрита',
};
